export const LOCATION_MASK = {
  'categories.primaryCategorySwitch': 'categories',
  categories: [
    'serviceArea.businessType',
    'serviceArea.places.placeInfos',
    'serviceItems',
  ],
  storeCodeSwitch: 'storeCode',
  titleSwitch: 'title',
  'openInfo.statusSwitch': 'openInfo.status',
  'openInfo.openingDateSwitch': 'openInfo.openingDate',
  storefrontAdressSwitch: [
    'storefrontAddress.regionCode',
    'storefrontAddress.languageCode',
    'storefrontAddress.postalCode',
    'storefrontAddress.administrativeArea',
    'storefrontAddress.locality',
    'storefrontAddress.sublocality',
    'storefrontAddress.addressLines',
  ],
  websiteUriSwitch: 'websiteUri',
  'phoneNumbers.primaryPhoneSwitch': 'phoneNumbers',
  'adWordsLocationExtensions.adPhoneSwitch':
    'adWordsLocationExtensions.adPhone',
  labelsSwitch: 'labels',
  'profile.descriptionSwitch': 'profile.description',
  openHoursFields: 'regularHours.periods',
  specialHoursFields: 'specialHours.specialHourPeriods',
}
